/* tempexp_16598-start */
export const cheapestProductIDs = {
    year: 'W1KB_1y_no_ads_single_quota_cloud',
    month: 'W1KB_1m_no_ads_single_quota_cloud',
};

export const cheapestTariffID = 'cheapest';
/* tempexp_16598-end */
